import { OmniTooltipNextComponent } from "../../../../../shared";
import OrderProgressCard from "./OrderProgressCard";
import ChannelPlanAlignment from "./ChannelPlanAlignment";

export default function PlanAlignmentCards({ planningSummary, channelsData }) {

    return (
        <div className="plan-alignment-cards">
            <h3 className="card-title">
                Plan Alignment &nbsp;
                <OmniTooltipNextComponent>
                    <div slot="invoker" aria-haspopup="true">
                        <omni-icon class="is-size-4" icon-id="omni:informative:info" />
                    </div>
                    <div slot="content">This shows your executed orders<br /> against the original media plan</div>
                </OmniTooltipNextComponent>
            </h3>
            <div className="sectionWrapper plan-alignment-info-cards">
                <div className="left-section">
                    <OrderProgressCard {...planningSummary} />
                </div>
                <div className="right-section">
                    <ChannelPlanAlignment channelsData={channelsData} />
                </div>
            </div>
        </div>
    );
}
